import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import SectionHeading from "./SectionHeading";
import { timeline } from "../data/site";

export default function ProcessTimeline() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 80%", "end 30%"],
  });
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section
      id="process"
      data-testid="process-section"
      ref={ref}
      className="relative py-28 md:py-40 px-6 md:px-12 bg-[#0c0c0f]"
    >
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="The Hoflich Process"
          title="Six steps from blueprint to occupancy."
          align="center"
          testId="process-heading"
        />

        <div className="relative mt-20">
          {/* Horizontal timeline desktop */}
          <div className="hidden lg:block relative">
            <div className="absolute top-[42px] left-0 right-0 h-px bg-white/10" />
            <motion.div
              style={{ scaleX: lineScale }}
              className="absolute top-[42px] left-0 right-0 h-px bg-[#C96A2B] origin-left"
            />
            <div className="grid grid-cols-6">
              {timeline.map((t, i) => (
                <motion.div
                  key={t.step}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ delay: i * 0.1, duration: 0.6 }}
                  data-testid={`process-step-${i}`}
                  className="px-4 text-center"
                >
                  <div className="flex flex-col items-center">
                    <span className="text-xs tracking-[0.3em] text-white/40">
                      {t.step}
                    </span>
                    <div className="mt-3 h-5 w-5 rounded-full border-2 border-[#C96A2B] bg-[#0c0c0f] relative">
                      <span className="absolute inset-1 rounded-full bg-[#C96A2B]" />
                    </div>
                    <h3 className="font-display text-xl mt-8">{t.title}</h3>
                    <p className="text-sm text-white/55 mt-2 leading-relaxed">
                      {t.desc}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Vertical timeline mobile/tablet */}
          <div className="lg:hidden relative pl-8">
            <div className="absolute left-3 top-0 bottom-0 w-px bg-white/10" />
            <motion.div
              style={{ scaleY: lineScale }}
              className="absolute left-3 top-0 bottom-0 w-px bg-[#C96A2B] origin-top"
            />
            <div className="space-y-10">
              {timeline.map((t, i) => (
                <motion.div
                  key={t.step}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ delay: i * 0.05, duration: 0.5 }}
                  className="relative"
                >
                  <span className="absolute -left-[26px] top-1 h-4 w-4 rounded-full border-2 border-[#C96A2B] bg-[#0c0c0f]">
                    <span className="absolute inset-0.5 rounded-full bg-[#C96A2B]" />
                  </span>
                  <span className="text-xs tracking-[0.3em] text-white/40">{t.step}</span>
                  <h3 className="font-display text-xl mt-1">{t.title}</h3>
                  <p className="text-sm text-white/55 mt-1">{t.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
